var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.4365525 16.6024012c0-1.1508045-.105186-2.2582732-.3008319-3.3203427h-15.5864591v6.2795543h8.9064479c-.3835782 2.0292129-1.5497402 3.748197-3.3021387 4.8996894v4.0728711h5.3483567c3.1296336-2.8264529 4.9346251-6.9880591 4.9346251-11.9317721z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5492615 32.4674071c4.4683006 0 8.2143241-1.4534668 10.9526659-3.9332338l-5.3483567-4.0728711c-1.4817199.9740222-3.3778725 1.5497684-5.6043092 1.5497684-4.3105216 0-7.95837156-2.8553434-9.2598728-6.6929634h-5.52927657v4.2063177c2.72291451 5.305532 8.31951007 8.9429822 14.78914937 8.9429822z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.2893887 19.3181072c-.33098523-.9740222-.51891752-2.0147677-.51891752-3.0844037 0-1.0696359.18793229-2.1103814.51891752-3.0844036v-4.20631771h-5.52927657c-1.12058135 2.19155001-1.76011213 4.67131701-1.76011213 7.29072131 0 2.6194044.63953078 5.0991714 1.76011213 7.2907214z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5492615 6.4563365c2.4297962 0 4.6113535.81925174 6.3265863 2.42748898l4.7466929-4.65618387c-2.8666687-2.6187165-6.6126922-4.22764161-11.0732792-4.22764161-6.468938 0-12.06623486 3.63813805-14.78914937 8.94298219l5.52927657 4.20631771c1.30150124-3.83693216 4.9500524-6.6929634 9.2598728-6.6929634z",
    fill: "#ea4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.849df390f918ae90ada80239e1faa3a3.svg";
export { ForwardRef as ReactComponent };